import { Input } from "@/components/ui/input";
import { formatToCurrency, selectAllOnFocus } from "@/lib/utils";
import React from "react";

interface CurrencyInputProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "value"
> {
  value: number | null | undefined;
  onChange: (value: number | null) => void;
}

const CurrencyInput = ({ value, onChange, ...props }: CurrencyInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = e.target.value;

    inputValue = inputValue.replace(/\D/g, "");

    if (!inputValue) {
      onChange(null);
      return;
    }

    const cents = parseInt(inputValue, 10);
    const newValue = cents / 100;

    onChange(newValue);
  };

  const displayValue =
    value !== null && value !== undefined ? formatToCurrency(value) : "";

  return (
    <Input
      {...props}
      // Digits are appended as cents, so typing into a filled value would shift
      // it instead of replacing it.
      {...selectAllOnFocus}
      value={displayValue}
      onChange={handleChange}
      placeholder="R$ 0,00"
    />
  );
};

export default CurrencyInput;
